import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {Store} from '@ngrx/store';

import {catchError, map, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {EmptyError, of} from 'rxjs';

import {AppState} from '@store/app.states';


import {UsersListService} from '../users-list.service';
import {
  RefreshListSuccess,
  RefreshListFailure,
  RefreshList,
  ConnectAs,
  DisplayUserDetail,
  GetUserDetailSuccess,
  GetUserDetailFailure,
  UpdateBatchExt,
  UpdateBatchExtSuccess,
  UpdateBatchExtFailure,
  MoveToCommunities,
  MoveToCommunitiesFailure,
  MoveToCommunitiesSuccess,
  addCreditToContributors,
  addCreditToContributorsSuccess,
  addCreditToContributorsFailure,
  getAllPartialFromMongoSuccess,
  AddUserSuccess,
  AddUserRequest, AddUserFailure
} from '../store/users-list.actions';
import {selectAdminUsersState} from '@app/4dm1n/users-list/store/users-list.selector';
import {ToastrService} from 'ngx-toastr';
import {JsonPipe} from '@angular/common';

@Injectable()
export class UsersListEffect {
  constructor(
    private actions: Actions,
    private store: Store<AppState>,
    private usersListService: UsersListService,
    private toastr: ToastrService,
    private jsonPipe: JsonPipe
  ) {
  }

  addUser = createEffect(() => this.actions.pipe(
    ofType(AddUserRequest),
    map((action) => action),
    switchMap(payload => {



      return this.usersListService.createUser(payload.userInfos)
        .pipe(
          map(data => AddUserSuccess({ user: data.data.datas.user })),
          catchError(error =>
            of(AddUserFailure({error}))
          )
        );
    }),
  ));

  refreshList = createEffect(() => this.actions.pipe(
    ofType(RefreshList),
    map((action) => action),
    switchMap(payload => {
      return this.usersListService.getUsersList(payload.nbMonths, payload.extProfils, payload.userIds, payload.emails, payload.communitiesIds)
        .pipe(
          map(data => RefreshListSuccess({usersList: data.data.usersList, sql: data.data.sql, secretToken: data.data.secretToken})),
          catchError(error =>
            of(RefreshListFailure({error}))
          )
        );
    }),
  ));


  UpdateBatchExt = createEffect(() => this.actions.pipe(
    ofType(UpdateBatchExt),
    map((action) => action),
    withLatestFrom(this.store.select(selectAdminUsersState)),
    map((state) => state),
    switchMap(([payload, state]) => {
      return this.usersListService.updateBatchExtProfils(payload.userIds, payload.updateExts, payload.deleteExt, payload.createLegacyEmailGroup)
        .pipe(
          map((data) => {

            // console.log(data.data.datas.result);

            if (data.data.datas.success) {

              // console.log(data.data.datas.result);

              this.toastr.info(
                `${this.jsonPipe.transform(data.data.datas.result)}`,
                'Batch update OK!',
                {
                  timeOut: 7000,
                  progressBar: true,
                  enableHtml: true,
                });

              return RefreshList(state.uxInteractions.lastRefreshListParams);

            } else {

              return UpdateBatchExtFailure({error: data});

            }

          })
          , catchError(error =>
            of(UpdateBatchExtFailure({error}))
          )
        );
    }),
  ));


  MoveToCommunities = createEffect(() => this.actions.pipe(
    ofType(MoveToCommunities),
    map((action) => action),
    withLatestFrom(this.store.select(selectAdminUsersState)),
    map((state) => state),
    switchMap(([payload, state]) => {
      return this.usersListService.moveToCommunities(payload.userIds, payload.communitiesIds)
        .pipe(
          map((data) => {

            // console.log(data.data.datas.result);

            if (data.data.datas.success) {

              // console.log(data.data.datas.result);

              this.toastr.info(
                `${this.jsonPipe.transform(data.data.datas.result)}`,
                'Batch update OK!',
                {
                  timeOut: 7000,
                  progressBar: true,
                  enableHtml: true,
                });

              return MoveToCommunitiesSuccess();

            } else {

              return MoveToCommunitiesFailure({error: data});

            }

          })
          , catchError(error =>
            of(MoveToCommunitiesFailure({error}))
          )
        );
    }),
  ));


  displayUserDetail = createEffect(() => this.actions.pipe(
    ofType(DisplayUserDetail),
    map((action) => action),
    switchMap(payload => {
      return this.usersListService.getUserDetails(payload.userId)
        .pipe(
          map(data => GetUserDetailSuccess({user: data.data.user})),
          catchError(error =>
            of(GetUserDetailFailure({error}))
          )
        );
    }),
  ));


  GetUserDetailSuccess = createEffect(() => this.actions.pipe(
    ofType(GetUserDetailSuccess),
    map((action) => action),
    switchMap(payload => {
      return this.usersListService.getAllPartialFromMongo(payload.user.id)
        .pipe(
          map(data => {
            // console.log(data.data.datas);
            return getAllPartialFromMongoSuccess({data: data.data.datas});
          }),
          catchError((error) => {
              this.toastr.error(error);
              return of(RefreshListFailure({error}));
              // return EmptyError;
            }
          )
        );
    }),
  ));


  connectAs = createEffect(() => this.actions.pipe(
    ofType(ConnectAs),
    map((action) => action),
    tap((payload) => {
      // console.log(payload.userId);
      this.usersListService.adminRedirectToUrl(payload.userId, payload.action);
      return ({type: 'done'});
    }),
  ), {dispatch: false});


  addCreditToContributors = createEffect(() => this.actions.pipe(
    ofType(addCreditToContributors),
    map((action) => action),
    withLatestFrom(this.store.select(selectAdminUsersState)),
    map((state) => state),
    switchMap(([payload, state]) => {

      return this.usersListService.addCreditToContributors(payload.userIds, payload.amount, payload.message)
        .pipe(
          map((data) => {

            if (data.data.datas.success) {

              this.toastr.info(
                `${this.jsonPipe.transform(data.data.datas.result)}`,
                'Credit added OK!',
                {
                  timeOut: 7000,
                  progressBar: true,
                  enableHtml: true,
                });

              if (state.uxInteractions.userDetail.currentUserId && state.uxInteractions.sideNav.appOpen) {
                this.store.dispatch(DisplayUserDetail({userId: state.uxInteractions.userDetail.currentUserId}));
              }
              return addCreditToContributorsSuccess();

            } else {

              return addCreditToContributorsFailure({error: data});

            }

          })
          , catchError(error =>
            of(addCreditToContributorsFailure({error}))
          )
        );
    }),
  ));


}
